import { render } from "./Bar.vue?vue&type=template&id=4d484b14&scoped=true&lang=pug"
import script from "./Bar.vue?vue&type=script&lang=js"
export * from "./Bar.vue?vue&type=script&lang=js"

import "./Bar.vue?vue&type=style&index=0&id=4d484b14&scoped=true&lang=css"

import exportComponent from "/Users/bestian/Documents/GitHub/food-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d484b14"]])

export default __exports__